import useLocalization from "@/hooks/useLocalization";
import icons from "@/tools/icons";
import GuideCard from "./GuideCard";

type PendingGuideCardProps = {
  numPendingGuides: number;
};
export default function PendingGuideCard({
  numPendingGuides,
}: PendingGuideCardProps) {
  const { t } = useLocalization();

  return (
    <GuideCard
      name={t("reservation:unknownGuides", {
        interpolation: {
          numGuides: numPendingGuides,
          guide: t("reservation:guide", {
            interpolation: { count: numPendingGuides },
          }),
        },
      })}
      phoneNumber={""}
      FallbackIcon={
        numPendingGuides === 2
          ? icons.TwoPeople
          : numPendingGuides > 2
          ? icons.Group
          : undefined
      }
    />
  );
}
